var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"ml-auto"},[_vm._v(" Oceanbolt Admin Interface ")])])}
var staticRenderFns = []

export { render, staticRenderFns }